/* Central contact + site config.
   Keep every phone/WhatsApp reference here so they cannot drift apart. */

/* Full international format, no "+" or spaces — required by wa.me links. */
export const WHATSAPP_NUMBER = "918235379736";

/* Display + tel: form of the same line. */
export const PHONE_DISPLAY = "+91 82353 79736";
export const PHONE_TEL = "+918235379736";

export const SITE_NAME = "Sai Concept";
export const SITE_TAGLINE = "Your Partner in Procurement";
export const SITE_URL = "https://saiconcept.in";

export function whatsappLink(message) {
  const base = `https://wa.me/${WHATSAPP_NUMBER}`;
  return message ? `${base}?text=${encodeURIComponent(message)}` : base;
}
